
















import { Vue, Component, Prop } from 'vue-property-decorator';
import { dayjs, DT_FORMAT_JA } from '../../../src_server/common/momentExtends';
import { LessonSummaryDTO } from '../../../src_server/entity/dto/LessonSummaryDTO';

@Component({
  components: {},
  filters: {
    formatDt(d: Date) {
      return dayjs(d).format(DT_FORMAT_JA);
    },
  },
})
export default class MatchingRow extends Vue {
  @Prop()
  private row!: LessonSummaryDTO;

  @Prop()
  private index!: number;
}
